import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";

const pages = [
  {
    path: "/",
    title: "Design manuál",
    content: pageLoader(() => import("./WELCOME.md"))
  },

  {
    title: "CERGO",
    pages: [
        {
          path: '/cergo/logo',
          title: 'Logo',
          content: pageLoader(() => import("./cergo/cergo_logo.md"))
        },
        {
          path: '/cergo/claim',
          title: 'Logo + Claim',
          content: pageLoader(() => import("./cergo/cergo_claim.md"))
        },
        {
          path: '/cergo/group',
          title: 'Skupina CERGO',
          content: pageLoader(() => import("./cergo/cergo_group.md"))
        },
        {
          path: '/cergo/pictogram',
          title: 'Piktogram',
          content: pageLoader(() => import("./cergo/cergo_pictogram.md"))
        },
        {
          path: '/cergo/colors',
          title: 'Barvy',
          content: pageLoader(() => import("./cergo/cergo_barvy.md"))
        },
        {
          path: '/cergo/font',
          title: 'Písmo',
          content: pageLoader(() => import("./cergo/cergo_pismo.md"))
        },
        {
          path: '/cergo/rules',
          title: 'Pravidla užívání loga',
          content: pageLoader(() => import("./cergo/cergo_rules.md"))
        }
      ]
  },
  {
    title: "CERGOENERGY",
    pages: [
        {
          path: '/cergoenergy/logo',
          title: 'Logo',
          content: pageLoader(() => import("./cergoenergy/cergoenergy_logo.md"))
        },
        {
          path: '/cergoenergy/claim',
          title: 'Logo + Claim',
          content: pageLoader(() => import("./cergoenergy/cergoenergy_claim.md"))
        },
        {
          path: '/cergoenergy/pictogram',
          title: 'Piktogram',
          content: pageLoader(() => import("./cergo/cergo_pictogram.md"))
        },
        {
          path: '/cergoenergy/colors',
          title: 'Barvy',
          content: pageLoader(() => import("./cergo/cergo_barvy.md"))
        },
        {
          path: '/cergoenergy/font',
          title: 'Písmo',
          content: pageLoader(() => import("./cergo/cergo_pismo.md"))
        },
        {
          path: '/cergoenergy/rules',
          title: 'Pravidla užívání loga',
          content: pageLoader(() => import("./cergoenergy/cergoenergy_rules.md"))
        }
      ]
  },
  {
    title: "CERGOMONT",
    pages: [
        {
          path: '/cergomont/logo',
          title: 'Logo',
          content: pageLoader(() => import("./cergomont/cergomont_logo.md"))
        },
        {
          path: '/cergomont/claim',
          title: 'Logo + Claim',
          content: pageLoader(() => import("./cergomont/cergomont_claim.md"))
        },
        {
          path: '/cergomont/pictogram',
          title: 'Piktogram',
          content: pageLoader(() => import("./cergo/cergo_pictogram.md"))
        },
        {
          path: '/cergomont/colors',
          title: 'Barvy',
          content: pageLoader(() => import("./cergo/cergo_barvy.md"))
        },
        {
          path: '/cergomont/font',
          title: 'Písmo',
          content: pageLoader(() => import("./cergo/cergo_pismo.md"))
        },
        {
          path: '/cergomont/rules',
          title: 'Pravidla užívání loga',
          content: pageLoader(() => import("./cergomont/cergomont_rules.md"))
        }
      ]
  },
  {
    title: "CERGONET",
    pages: [
        {
          path: '/cergonet/logo',
          title: 'Logo',
          content: pageLoader(() => import("./cergonet/cergonet_logo.md"))
        },
        {
          path: '/cergonet/claim',
          title: 'Logo + Claim',
          content: pageLoader(() => import("./cergonet/cergonet_claim.md"))
        },
        {
          path: '/cergonet/pictogram',
          title: 'Piktogram',
          content: pageLoader(() => import("./cergo/cergo_pictogram.md"))
        },
        {
          path: '/cergonet/colors',
          title: 'Barvy',
          content: pageLoader(() => import("./cergo/cergo_barvy.md"))
        },
        {
          path: '/cergonet/font',
          title: 'Písmo',
          content: pageLoader(() => import("./cergo/cergo_pismo.md"))
        },
        {
          path: '/cergonet/rules',
          title: 'Pravidla užívání loga',
          content: pageLoader(() => import("./cergonet/cergonet_rules.md"))
        }
      ]
  },
  {
    title: "30 let",
    pages: [
        {
          path: '/30let/logo',
          title: 'Logo',
          content: pageLoader(() => import("./30let/30let_logo.md"))
        },
        {
          path: '/30let/colors',
          title: 'Barvy',
          content: pageLoader(() => import("./30let/30let_barvy.md"))
        }        
      ]
  },
  {
    path: '/signature',
    title: "E-mailový podpis",
    content: pageLoader(() => import("./email_signature/cergo_signature.jsx")),
  }
];
const theme = {
    background: "#F9F9F9",
    textColor: "#2C2A29",
    codeColor: "#00263E",
    linkColor: "#C00D1E",
    navBarBackground: "#F2F2F2",
    navBarTextColor: "#2C2A29",
    pageHeadingHeight: 150,
    pageHeadingBackground: "#C00D1E",
    pageHeadingTextColor: "#fff",
    brandColor: "#2C2A29",

    sidebarColor: "#FFFFFF",
    sidebarColorText: "#2C2A29",
    sidebarColorTextActive: "#C00D1E",
    sidebarColorLine: "#EBEBEB",
    sidebarColorHeading: "#003B5C",

    // Used in the html, react, and image specimens.
    bgLight: "#FFFFFF",
    bgDark: "#2C2A29",

    fontFamily: "'Cairo', sans-serif",
    fontHeading: "'Cairo', sans-serif",
    }

  const logoSrc = 'cergo_logo.svg'

ReactDOM.render(
  <Catalog title="CERGO" logoSrc={logoSrc} styles="./main.css" pages={pages} theme={theme} />,
  document.getElementById("catalog")
);



// WEBPACK FOOTER //
// ./catalog/index.js